import React from 'react';
import MetaTag from "../../components/MetaTag/MetaTag";
import YouTubeChannel from '../../components/VideoPlayer/YouTubeChannel';
const YouTubePage = () => {
    return (
        <>
            <MetaTag title={"BCE Global Tech YouTube Videos"} description={""} />
        <div>
            <YouTubeChannel />
          </div>
        </>
    );
};

export default YouTubePage;